// extracted by mini-css-extract-plugin
module.exports = {"Order":"Order_Order__3QxfR","Burger":"Order_Burger__ag-Pe"};